<template>
  <div style="padding: 15px">
    <div style="margin-bottom: 20px;" v-if="!isRed">
      <vxe-toolbar
        id="toolbarId_ca5"
        :custom="{ storage: true }"
        export
        :refresh="{ query: funcFilter }"
      >
        <template v-slot:buttons>
          <el-button @click="funcFilter">查询</el-button>
          <el-button @click="funcExport">导出</el-button>
        </template>
      </vxe-toolbar>
      <vxe-table
        ref="xTable"
        border
        resizable
        stripe
        highlight-current-row
        highlight-hover-row
        row-id="id"
        export-config
        :loading="loading"
        :data="tableData"
      >
        <!-- <vxe-table-column type="checkbox" width="60" fixed="left" /> -->
        <!-- 机构 -->
        <!-- <vxe-table-column>
          <vxe-table-column
            field="branchCode"
            title="机构"
            :formatter="formatterBranch"
            min-width="180"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="checkQuery.branchCode"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in branchList"
                :key="item.code"
                :label="item.groupName"
                :value="item.code"
              />
            </el-select>
          </template>
        </vxe-table-column> -->

        <!-- 运单号 -->
        <vxe-table-column>
          <vxe-table-column
            field="orderCode"
            title="运单号"
            min-width="220"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.orderCode"
              placeholder="请输入运单号"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 托运人 -->
        <vxe-table-column>
          <vxe-table-column
            field="companyName"
            title="托运人"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.companyName"
              placeholder="请输入托运人"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 装货数量 -->
        <vxe-table-column>
          <vxe-table-column
            field="loadQuantity"
            title="装货数量"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.loadQuantity"
              placeholder="请输入装货数量"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 卸货数量 -->
        <vxe-table-column>
          <vxe-table-column
            field="unloadQuantity"
            title="卸货数量"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.unloadQuantity"
              placeholder="请输入卸货数量"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 里程数 -->
        <vxe-table-column>
          <vxe-table-column
            field="distance"
            title="里程数(公里)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.distance"
              placeholder="请输入里程数"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 托运人实付运费 -->
        <vxe-table-column>
          <vxe-table-column
            v-if="isShipmentOrAdmin"
            field="shipmentActualFreight"
            title="托运人实付运费(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.shipmentActualFreight"
              placeholder="请输入托运人实付运费"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 实际承运人实收运费 -->
        <vxe-table-column>
          <vxe-table-column
            v-if="isDriverOrAdmin"
            field="driverActualFreight"
            title="实际承运人实收运费(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.driverActualFreight"
              placeholder="请输入实际承运人实收运费"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 货物名称 -->
        <vxe-table-column>
          <vxe-table-column
            field="coalTypeName"
            title="货物名称"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.coalTypeName"
              placeholder="请输入货物名称"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 装货地址 -->
        <vxe-table-column>
          <vxe-table-column
            field="placeOfShipment"
            title="装货地址"
            min-width="450"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.placeOfShipment"
              placeholder="请输入装货地址"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 卸货地址 -->
        <vxe-table-column>
          <vxe-table-column
            field="placeOfReceipt"
            title="卸货地址"
            min-width="450"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.placeOfReceipt"
              placeholder="请输入卸货地址"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 实际承运人姓名 -->
        <vxe-table-column>
          <vxe-table-column
            field="driverName"
            title="实际承运人姓名"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.driverName"
              placeholder="请输入实际承运人姓名"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 实际承运人电话 -->
        <vxe-table-column>
          <vxe-table-column
            field="driverPhone"
            title="实际承运人电话"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.driverPhone"
              placeholder="请输入实际承运人电话"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 车牌号 -->
        <vxe-table-column>
          <vxe-table-column
            field="vehicleLicense"
            title="车牌号"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.vehicleLicense"
              placeholder="请输入车牌号"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 结算类型 -->
        <!-- todo结算类型 -->
        <vxe-table-column
          field="isMonthlyOrder"
          title="结算类型"
          min-width="100"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'isMonthlyOrder')
          "
          sortable
        />
        <!-- 运输要求 -->
        <vxe-table-column>
          <vxe-table-column
            field="coalName"
            title="运输要求"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.coalName"
              placeholder="请输入运输要求"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 最后操作时间 -->
        <vxe-table-column>
          <vxe-table-column
            field="gmtModified"
            title="最后操作时间"
            min-width="420"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="checkQuery.gmtModifiedRange"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              :picker-options="optionsPicker"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'gmtModified')"
            />
          </template>
        </vxe-table-column>
        <!-- 最后操作人 -->
        <vxe-table-column>
          <vxe-table-column
            field="modifiedByName"
            title="最后操作人"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.modifiedByName"
              placeholder="请输入最后操作人"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 货源单号 -->
        <!-- <vxe-table-column>
          <vxe-table-column
            field="mainOrderNumber"
            title="货源单号"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.mainOrderNumber"
              placeholder="请输入货源单号"
              clearable
            />
          </template>
        </vxe-table-column> -->
        <!-- 经办人 -->
        <!-- <vxe-table-column>
          <vxe-table-column
            field="ordCreatedByName"
            title="经办人"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.ordCreatedByName"
              placeholder="请输入经办人"
              clearable
            />
          </template>
        </vxe-table-column> -->

        <!-- 托运人名称 -->
        <!-- <vxe-table-column>
          <vxe-table-column
            field="shipmentName"
            title="申请人"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.shipmentName"
              placeholder="请输入托运人名称"
              clearable
            />
          </template>
        </vxe-table-column> -->

        <!-- <vxe-table-column>
          <vxe-table-column
            field="loadPlace"
            title="实际操作装货地址"
            min-width="450"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.loadPlace"
              placeholder="请输入实际操作装货地址"
              clearable
            />
          </template>
        </vxe-table-column> -->

        <!-- <vxe-table-column>
          <vxe-table-column
            field="unloadPlace"
            title="实际操作卸货地址"
            min-width="450"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.unloadPlace"
              placeholder="请输入实际操作卸货地址"
              clearable
            />
          </template>
        </vxe-table-column> -->

        <!-- <vxe-table-column>
          <vxe-table-column
            field="teamName"
            title="承运车队"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.teamName"
              placeholder="请输入承运车队"
              clearable
            />
          </template>
        </vxe-table-column> -->
        <!-- <vxe-table-column>
          <vxe-table-column
            field="weight"
            title="接单数量"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.weight"
              placeholder="请输入接单数量"
              clearable
            />
          </template>
        </vxe-table-column> -->

        <!-- <vxe-table-column>
          <vxe-table-column
            v-if="isShipmentOrAdmin"
            field="taxPrice"
            title="托运人成交单价"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.taxPrice"
              placeholder="请输入托运人成交单价"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            v-if="isDriverOrAdmin"
            field="realPrice"
            title="实际承运人承运单价"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.realPrice"
              placeholder="请输入实际承运人承运单价"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            v-if="isShipmentOrAdmin"
            field="taxFee"
            title="托运人预估运费(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.taxFee"
              placeholder="请输入托运人预估运费"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            v-if="isDriverOrAdmin"
            field="deliveryFeeDeserved"
            title="实际承运人预估运费(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.deliveryFeeDeserved"
              placeholder="请输入实际承运人预估运费"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="settlementWeight"
            title="结算吨位"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.settlementWeight"
              placeholder="请输入结算吨位"
              clearable
            />
          </template>
        </vxe-table-column>

        <vxe-table-column>
          <vxe-table-column
            v-if="isDriverOrAdmin"
            field="driverActualCash"
            title="实际承运人实收现金(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.driverActualCash"
              placeholder="请输入实际承运人实收现金"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            v-if="isDriverOrAdmin"
            field="deliveryCashFee"
            title="实际承运人合计收款(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.deliveryCashFee"
              placeholder="请输入实际承运人合计收款"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="coalPrice"
            title="货物单价(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.coalPrice"
              placeholder="请输入货物单价"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            v-if="isShipmentOrAdmin"
            field="payTaxAmount"
            title="托运人预付金额(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.payTaxAmount"
              placeholder="请输入托运人预付金额"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            v-if="isShipmentOrAdmin"
            field="shipmentActualCash"
            title="托运人实付现金(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.shipmentActualCash"
              placeholder="请输入托运人实付现金"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            v-if="isShipmentOrAdmin"
            field="shipperDeliveryFee"
            title="托运人合计付款(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.shipperDeliveryFee"
              placeholder="请输入托运人合计付款"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="platformPrepayment"
            title="平台预付金额(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="checkQuery.platformPrepayment"
              placeholder="请输入平台预付金额"
              clearable
            />
          </template>
        </vxe-table-column> -->
        <!-- <vxe-table-column field="gmtCreated" title="接单时间" min-width="420" sortable /> -->
        <!-- <vxe-table-column>
          <vxe-table-column
            field="lastLoadingTime"
            title="截止装货时间"
            min-width="420"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="checkQuery.lastLoadingTimeRange"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              :picker-options="optionsPicker"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'lastLoadingTime')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="fillTime"
            title="装车时间"
            min-width="420"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="checkQuery.fillTimeRange"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              :picker-options="optionsPicker"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'fillTime')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="lastUnloadingTime"
            title="截止卸货时间"
            min-width="420"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="checkQuery.lastUnloadingTimeRange"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              :picker-options="optionsPicker"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'lastUnloadingTime')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="signTime"
            title="卸车时间"
            min-width="420"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="checkQuery.signTimeRange"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              :picker-options="optionsPicker"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'signTime')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="gmtCreated"
            title="创建时间"
            min-width="420"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="checkQuery.gmtCreatedRange"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              :picker-options="optionsPicker"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'gmtCreated')"
            />
          </template>
        </vxe-table-column> -->
      </vxe-table>
    </div>
    <div v-if="!isRed">
      <el-form ref="form" label-width="100px" :model="invoice">
        <el-row>
          <el-col :span="10">
            <el-form-item label="发票号码">
              <el-input v-model="invoice.invoiceNumber" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="2">
            <el-form-item label="开票总金额">
              <el-input v-model="invoice.invoiceAmount" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="invoice.invoiceImg">
          <el-col :span="20">
            <el-form-item label="发票图片">
              <!-- <div class="img_box">
                <el-image
                  style="width: 400px; height: 300px"
                  :fit="'contain'"
                  :src="invoice.invoiceImg"
                  :preview-src-list="[invoice.invoiceImg]"
                />
                <i
                  class="icon_top el-icon-download"
                  @click="downloadImg(invoice.invoiceImg)"
                ></i>
              </div> -->
              <div class="review_btn" @click="isReview = true">预览</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- <InvoiceMessage
      ref="invoiceMessageRef"
      type="detail"
      :latestRecord="sigleInfo"
      style="margin-top: -40px"
    ></InvoiceMessage> -->
    <div v-if="!isRed" style="margin-top:20px;display:flex;">
      <div style="margin-bottom:9px;font-weight:bold;margin-left:32px;">
        发票备注
      </div>
      <el-input
        style="width:480px;margin-left:12px;"
        type="textarea"
        :rows="3"
        :disabled="true"
        placeholder="请输入发票备注"
        v-model="sigleInfo.remark"
      ></el-input>
    </div>
    <!-- 红冲发票详情 -->
    <div v-if="isRed && redInfo">
      <vxe-table
        ref="xTable"
        border
        resizable
        stripe
        highlight-current-row
        highlight-hover-row
        row-id="id"
        export-config
        :loading="loading"
        :data="redInfo"
      >
        <vxe-table-column field="redNum" title="红冲发票号码" min-width="220" />
        <vxe-table-column
          field="redInvoiceAmount"
          title="红冲开票总金额"
          min-width="220"
        />
        <vxe-table-column
          field="blueNum"
          title="被红冲发票号码"
          min-width="220"
        />
      </vxe-table>
      <el-row>
        <!-- <el-col :span="8">
          <span style="font-weight:bold;font-size:16px;margin-right:5px;"
            >红冲发票号码:</span
          >
          <span style="font-size:16px;">{{ redInfo.redNum }}</span>
        </el-col>
        <el-col :span="8">
          <span style="font-weight:bold;font-size:16px;margin-right:5px;"
            >红冲开票总金额:</span
          >
          <span style="font-size:16px;">{{ redInfo.redInvoiceAmount }}</span>
        </el-col>
        <el-col :span="8">
          <span style="font-weight:bold;font-size:16px;margin-right:5px;"
            >被红冲发票号码:</span
          >
          <span style="font-size:16px;">{{ redInfo.blueNum }}</span>
        </el-col> -->
        <el-col :span="24" style="margin-top:20px;margin-bottom:20px;">
          <span style="font-weight:bold;font-size:16px;margin-right:5px;"
            >备注:</span
          >
          <span style="font-size:16px;">{{ redInfo[0].redRemark }}</span>
        </el-col>
        <el-col :span="8">
          <span style="font-weight:bold;font-size:16px;margin-right:15px;"
            >发票预览:</span
          >
          <span class="review_btn" @click="isReview = true">预览</span>
        </el-col>
      </el-row>
    </div>
    <downloadData ref="downloadRef" />
    <!-- <el-dialog
      title="发票详情"
      :visible.sync="isReview"
      width="70%"
      :before-close="handleClose"
      modal-append-to-body
      append-to-body
    > -->
    <vxe-modal
      v-if="isReview"
      v-model="isReview"
      title="发票详情"
      width="1200"
      height="700"
      resize
    >
      <template v-if="!isImageUrl(imgUrl)">
        <iframe
          style="width:100%;height:100%;"
          :src="imgUrl"
          frameborder="0"
        ></iframe>
      </template>
      <div class="img_box" v-if="isImageUrl(imgUrl)">
        <img :src="imgUrl" alt="" />
        <div class="icon_top" @click="downloadImg(invoice.invoiceImg)">
          下载图片
        </div>
      </div>
    </vxe-modal>
    <!-- </el-dialog> -->
  </div>
</template>
<script>
import InvoiceMessage from "@/components/InvoiceMessage";
import { invoiceSimpleDetail, queryRed } from "@/api/invoice";
export default {
  name: "InvoiceDetail",
  components: {
    InvoiceMessage
  },
  props: {
    belongsTo: {
      type: String,
      default() {
        return "audit";
      }
    },
    sigleInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      remark: "",
      isReview: false,
      exportObj: {
        exportUrl: "/ntocc-basic-api/invoice/exportShipmentDetail", //导出接口
        name: "开票审核详情"
      },
      loading: false,
      tableData: [],
      invoice: {},
      lastLoadingTimeRange: "",
      fillTimeRange: "",
      lastUnloadingTimeRange: "",
      signTimeRange: "",
      gmtCreatedRange: "",
      gmtModifiedRange: "",
      parentData: {
        isMonthlyOrderOptions: []
      },
      checkQuery: {
        branchCode: "",
        orderCode: "",
        mainOrderNumber: "",
        ordCreatedByName: "",
        shipmentName: "",
        companyName: "",
        coalTypeName: "",
        coalName: "",
        placeOfShipment: "",
        loadPlace: "",
        placeOfReceipt: "",
        unloadPlace: "",
        driverName: "",
        driverPhone: "",
        vehicleLicense: "",
        teamName: "",
        weight: "",
        loadQuantity: "",
        unloadQuantity: "",
        distance: "",
        taxPrice: "",
        realPrice: "",
        taxFee: "",
        deliveryFeeDeserved: "",
        settlementWeight: "",
        shipmentActualFreight: "",
        driverActualFreight: "",
        driverActualCash: "",
        deliveryCashFee: "",
        coalPrice: "",
        payTaxAmount: "",
        shipmentActualCash: "",
        shipperDeliveryFee: "",
        platformPrepayment: "",
        lastLoadingTimeRange: "",
        fillTimeRange: "",
        lastUnloadingTimeRange: "",
        signTimeRange: "",
        gmtCreatedRange: "",
        gmtModifiedRange: "",
        modifiedByName: ""
      },
      listQuery: {
        code: "",
        pageNum: 1,
        pageSize: 9999,
        total: 0 // 导出功能用到，禁止注释
        // pageNum: 1,
        // pageSize: 20,
        // gmtCreatedStart: "",
        // gmtCreatedEnd: "",
        // lastUnloadingTimeStart: "",
        // lastUnloadingTimeEnd: "",
        // lastLoadingTimeStart: "",
        // lastLoadingTimeEnd: "",
        // gmtModifiedStart: "",
        // gmtModifiedEnd: "",
        // fillTimeStart: "",
        // fillTimeEnd: "",
        // signTimeStart: "",
        // signTimeEnd: "",
        // ordCreatedByName: "",
        // isUnloadingConfirm: 1,
      },
      // code: "",
      isAdmin: false,
      isShipmentOrAdmin: false,
      isDriverOrAdmin: false,
      // 机构列表
      branchList: this.$store.state.components.branchList,
      isRed: false,
      redInfo: null
    };
  },
  created() {
    // 区分 发票列表 和 开票审核
    if (this.belongsTo === "list") {
      this.exportObj = {
        exportUrl: "/ntocc-basic-api/invoice/exportInvoiceDetail", //导出接口
        name: "发票详情"
      };
    }
    const partyType = this.$store.getters.party.partyType;
    const isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.isAdmin = isAdmin;
    this.isShipmentOrAdmin =
      partyType == "SHIPMENT" || partyType == "SHIPMENT_COMPANY" || isAdmin;
    this.isDriverOrAdmin =
      partyType == "DRIVER" || partyType == "DRIVER_LEADER" || isAdmin;
    this.parentData.isMonthlyOrderOptions = [
      { label: "次结", value: 0 },
      { label: "月结", value: 1 }
    ];
  },
  computed: {
    imgUrl() {
      return this.invoice.invoiceImg.replace(/^http:/, "https:");
    }
  },
  methods: {
    isImageUrl(url) {
      const cleanUrl = url.split("?")[0];
      const dotIndex = cleanUrl.lastIndexOf(".");
      if (dotIndex === -1) return false;
      const extension = cleanUrl.slice(dotIndex + 1).toLowerCase();
      const imageExtensions = [
        "png",
        "jpg",
        "jpeg",
        "gif",
        "bmp",
        "webp",
        "svg"
      ];
      return imageExtensions.includes(extension);
    },
    downloadImg(imageUrl) {
      let Url = imageUrl.replace(/^http:/, "https:");
      const link = document.createElement("a");
      link.href = Url;
      link.download = "发票图片"; // 自动获取文件名
      link.click();
    },
    // 查询
    async funcFilter() {
      this.getInfo(this.listQuery.code);
    },
    changeRange() {
      console.log("处理时间====", this.checkQuery);
      let checkQuery = JSON.parse(JSON.stringify(this.checkQuery));
      if (checkQuery.lastLoadingTimeRange.length === 2) {
        checkQuery.lastLoadingTimeStart = checkQuery.lastLoadingTimeRange[0];
        checkQuery.lastLoadingTimeEnd = checkQuery.lastLoadingTimeRange[1];
      }
      if (checkQuery.fillTimeRange.length === 2) {
        checkQuery.fillTimeStart = checkQuery.fillTimeRange[0];
        checkQuery.fillTimeEnd = checkQuery.fillTimeRange[1];
      }
      if (checkQuery.lastUnloadingTimeRange.length === 2) {
        checkQuery.lastUnloadingTimeStart =
          checkQuery.lastUnloadingTimeRange[0];
        checkQuery.lastUnloadingTimeEnd = checkQuery.lastUnloadingTimeRange[1];
      }
      if (checkQuery.signTimeRange.length === 2) {
        checkQuery.signTimeStart = checkQuery.signTimeRange[0];
        checkQuery.signTimeEnd = checkQuery.signTimeRange[1];
      }
      if (checkQuery.gmtCreatedRange.length === 2) {
        checkQuery.gmtCreatedStart = checkQuery.gmtCreatedRange[0];
        checkQuery.gmtCreatedEnd = checkQuery.gmtCreatedRange[1];
      }
      if (checkQuery.gmtModifiedRange.length === 2) {
        checkQuery.gmtModifiedStart = checkQuery.gmtModifiedRange[0];
        checkQuery.gmtModifiedEnd = checkQuery.gmtModifiedRange[1];
      }
      delete checkQuery.lastLoadingTimeRange;
      delete checkQuery.fillTimeRange;
      delete checkQuery.lastUnloadingTimeRange;
      delete checkQuery.signTimeRange;
      delete checkQuery.gmtCreatedRange;
      delete checkQuery.gmtModifiedRange;
      return checkQuery;
    },
    async getRedInfo(code) {
      try {
        this.isRed = true;
        let res = await queryRed({ code });
        console.log("红票详情==========", res);
        let info = res.data;
        let obj = {
          redNum: "",
          redRemark: "",
          redInvoiceAmount: "",
          blueNum: "",
          redUrl: ""
        };
        info.forEach(item => {
          if (item.invoiceType === 2) {
            // 红票
            obj.redNum = item.invoiceNumber;
            obj.redRemark = item.remark;
            obj.redInvoiceAmount = item.invoiceAmount;
            obj.redUrl = item.baiwangPdfurl;
            this.invoice.invoiceImg = item.baiwangPdfurl;
          } else if (item.invoiceType === 1) {
            obj.blueNum = item.invoiceNumber;
            // 蓝票
          }
        });
        this.redInfo = [obj];
        console.log("处理===========", this.redInfo);
      } catch (err) {}
    },
    // 获取页面信息
    getInfo(code) {
      this.listQuery.code = code;
      this.isRed = false;
      this.tableData = [];
      this.invoice = {};
      let newValue = this.changeRange();
      let data = {
        code,
        ...newValue
      };
      console.log("处理的数据=======", data);
      invoiceSimpleDetail(data).then(response => {
        this.tableData = response.data.detailList;

        this.tableData.forEach(item => {
          item.price = item.price + item.isTrunkName;
          item.realPrice = item.realPrice + item.isTrunkName;
          item.coalPrice = item.coalPrice + "元/" + item.coalUnitName;
          item.maxPrice = item.maxPrice + item.isTrunkName;
          item.weight = item.weight + item.coalUnitName;
        });
        this.invoice = response.data.invoice;
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item1 => item1.code === cellValue);
      return item ? item.groupName : "";
    },
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        item1 => item1.value === cellValue
      );
      return item ? item.label : "";
    }
  }
};
</script>
<style scoped lang="scss">
.review_btn {
  cursor: pointer;
  color: rgb(64, 158, 255);
  &:hover {
    opacity: 0.7;
  }
}
.img_box {
  width: 100%;
  height: 100%;
  position: relative;
  .icon_top {
    position: absolute;
    bottom: 20px;
    right: 15px;
    color: rgb(64, 158, 255);
    font-size: 18px;
    cursor: pointer;
  }
}
</style>
